import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import ProHero from "../sections/pro/ProHero";
import ProAudiences from "../sections/pro/ProAudiences";
import ProEcosystem from "../sections/pro/ProEcosystem";
import ProEnquiryForm from "../sections/pro/ProEnquiryForm";
import ProClosing from "../sections/pro/ProClosing";

const ProPage = () => (
    <div className="min-h-screen bg-pro-navy text-pro-platinum">
        <Seo
            title="BuildEase Pro | Construction & Property Intelligence for Professionals"
            description="BuildEase Pro is developing a connected construction and property intelligence ecosystem for quantity surveyors, architects, engineers, contractors, developers and property professionals in South Africa."
        />
        <Navbar />
        <main>
            <ProHero />
            <ProAudiences />
            <ProEcosystem />
            <ProEnquiryForm />
            <ProClosing />
        </main>
        <Footer />
    </div>
);

export default ProPage;
